// You can write more code here

import {
  getAnchorPlugin,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class SpeedBonusFeedbackContainer
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // speedBonusFeedbackBacking
    const speedBonusFeedbackBacking = scene.add.image(0, 0, '1x1sprite');
    speedBonusFeedbackBacking.scaleX = 256;
    speedBonusFeedbackBacking.scaleY = 99;
    speedBonusFeedbackBacking.alpha = 0.5;
    speedBonusFeedbackBacking.alphaTopLeft = 0.5;
    speedBonusFeedbackBacking.alphaTopRight = 0.5;
    speedBonusFeedbackBacking.alphaBottomLeft = 0.5;
    speedBonusFeedbackBacking.alphaBottomRight = 0.5;
    speedBonusFeedbackBacking.tintTopLeft = 0;
    speedBonusFeedbackBacking.tintTopRight = 0;
    speedBonusFeedbackBacking.tintBottomLeft = 0;
    speedBonusFeedbackBacking.tintBottomRight = 0;
    this.add(speedBonusFeedbackBacking);

    // speedBonusFeedbackText
    const speedBonusFeedbackText = scene.add.bitmapText(
      0,
      -28,
      'Aronui',
      'Speed Bonus!',
    );
    speedBonusFeedbackText.setOrigin(0.5, 0.5);
    speedBonusFeedbackText.text = 'Speed Bonus!';
    speedBonusFeedbackText.fontSize = -30;
    this.add(speedBonusFeedbackText);

    // speedBonusRubiesGainedText
    const speedBonusRubiesGainedText = scene.add.bitmapText(
      4,
      17,
      'Aronui',
      '+2',
    );
    speedBonusRubiesGainedText.setOrigin(0, 0.5);
    speedBonusRubiesGainedText.text = '+2';
    speedBonusRubiesGainedText.fontSize = -30;
    this.add(speedBonusRubiesGainedText);

    // speedBonusRubyIcon
    const speedBonusRubyIcon = scene.add.image(0, 14, 'hud-icons', 95);
    speedBonusRubyIcon.scaleX = 4;
    speedBonusRubyIcon.scaleY = 4;
    speedBonusRubyIcon.setOrigin(1, 0.5);
    this.add(speedBonusRubyIcon);

    this.speedBonusRubiesGainedText = speedBonusRubiesGainedText;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private speedBonusRubiesGainedText: Phaser.GameObjects.BitmapText;

  /* START-USER-CODE */

  awake() {
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  async showSpeedBonusFeedback(speedBonus: number) {
    this.speedBonusRubiesGainedText.setText(`+${speedBonus}`);
    this.setVisible(true);
    // this.setAlpha(0);
    console.log('showing speed bonus feedback', speedBonus);
    // Fade tween
    this.scene.tweens.add({
      targets: this,
      alpha: 1,
      duration: 400,
      ease: 'Power2',
    });
    // Scale tween
    this.scene.tweens.add({
      targets: this,
      scale: 1.1,
      duration: 1000,
      ease: 'Power2',
      yoyo: true,
    });

    await waitForSeconds(this.scene.time, 1);
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      duration: 400,
      ease: 'Power2',
      onComplete: () => {
        this.setVisible(false);
      },
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
